export default __webpack_public_path__ + "static/media/FECHAS_03.84bd3e7e.png";